import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import _ from "lodash";
import PlacesAutocomplete from "react-places-autocomplete";
import injectScript from "react-inject-script";
import { InputGroup, FormControl, FormLabel, Spinner, Card } from "react-bootstrap";
import classNames from "classnames";

var ReactPlaceField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactPlaceField, _Component);

  function ReactPlaceField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      googleApiLoaded: false,
      loading: true,
      value: "",
      hasError: false,
      id: Math.floor(Math.random() * 100)
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: value
      });

      onChange && onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (value, placeId, placeObject) {
      var _this$props = _this.props,
          onPlaceSelect = _this$props.onPlaceSelect,
          onChange = _this$props.onChange;

      _this.setState({
        value: value
      });

      placeObject && onChange && onChange(placeObject.description);
      onPlaceSelect && onPlaceSelect(placeObject);
    });

    return _this;
  }

  var _proto = ReactPlaceField.prototype;

  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var googleApiKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.setState({
                loading: true
              });
              googleApiKey = _.get(this.props, "uiSchema.ui:options.api");

              if (!googleApiKey) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return injectScript("googleapi", "https://maps.googleapis.com/maps/api/js?key=" + googleApiKey + "&libraries=places");

            case 6:
              setTimeout(function () {
                _this2.setState({
                  googleApiLoaded: true,
                  loading: false
                });
              }, 2000);
              _context.next = 10;
              break;

            case 9:
              throw Error("No Google API Key");

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              this.setState({
                hasError: "Cannot load because of missing Google API key",
                loading: false
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 12]]);
    }));

    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }

    return componentDidMount;
  }();

  _proto.componentDidUpdate = function componentDidUpdate() {};

  _proto.renderPlaceInput = function renderPlaceInput(_ref) {
    var _this3 = this;

    var getInputProps = _ref.getInputProps,
        getSuggestionItemProps = _ref.getSuggestionItemProps,
        suggestions = _ref.suggestions,
        loading = _ref.loading;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputGroup, {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(FormControl, getInputProps()), " ", !_.isEmpty(suggestions) && /*#__PURE__*/React.createElement("div", {
      className: "autocomplete-dropdown-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wrapper"
    }, loading && /*#__PURE__*/React.createElement("div", {
      className: "loading"
    }, "Loading..."), suggestions.map(function (suggestion, index) {
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames({
          suggestion: true,
          active: suggestion.active
        })
      }, getSuggestionItemProps(suggestion), {
        key: _this3.state.id + "-" + index
      }), /*#__PURE__*/React.createElement("span", null, suggestion.description));
    })))));
  };

  _proto.renderLoading = function renderLoading() {
    return /*#__PURE__*/React.createElement(Card, {
      className: "text-center"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      size: "sm",
      role: "status"
    }), " Loading..."));
  };

  _proto.render = function render() {
    var _this4 = this;

    var schema = this.props.schema;
    var _this$state = this.state,
        googleApiLoaded = _this$state.googleApiLoaded,
        hasError = _this$state.hasError,
        loading = _this$state.loading;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormLabel, null, schema.title), loading && this.renderLoading(), !loading && googleApiLoaded && /*#__PURE__*/React.createElement(PlacesAutocomplete, {
      value: this.state.value,
      onChange: this.handleChange,
      onSelect: this.handleSelect
    }, function (placeProps) {
      return _this4.renderPlaceInput(placeProps);
    }), !loading && !googleApiLoaded && hasError && /*#__PURE__*/React.createElement("div", {
      className: "dropzone"
    }, /*#__PURE__*/React.createElement("div", null, hasError)));
  };

  return ReactPlaceField;
}(Component);

export default ReactPlaceField;